import type { CSSProperties } from 'react';
import { css } from 'styled-components';

export const WORKFLOW_SELECTOR_BORDER_COLOR = '#a0a0a0';
export const WORKFLOW_SELECTOR_BORDER_RADIUS = '4px';
export const WORKFLOW_SELECTOR_BACKGROUND = '#fff';
export const WORKFLOW_SELECTOR_FONT_SIZE = '13px';
export const WORKFLOW_SELECTOR_LINE_HEIGHT = '1.5';
export const WORKFLOW_SELECTOR_PADDING_Y = '8px';
export const WORKFLOW_SELECTOR_PADDING_LEFT = '8px';
export const WORKFLOW_SELECTOR_ARROW_SIZE = 24;
export const WORKFLOW_SELECTOR_ARROW_RIGHT = '7px';
export const WORKFLOW_SELECTOR_ARROW_TOP = 'calc(50% - 12px)';
export const WORKFLOW_SELECTOR_PADDING_RIGHT = '24px';
export const WORKFLOW_SELECTOR_DROPDOWN_SHADOW = '0 2px 8px rgba(0, 0, 0, 0.15)';

export const workflowSelectorArrowStyle: CSSProperties = {
  position: 'absolute',
  top: WORKFLOW_SELECTOR_ARROW_TOP,
  right: WORKFLOW_SELECTOR_ARROW_RIGHT,
  width: WORKFLOW_SELECTOR_ARROW_SIZE,
  height: WORKFLOW_SELECTOR_ARROW_SIZE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'rgba(0, 0, 0, 0.54)',
  pointerEvents: 'none',
  transition: 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
};

export const workflowSelectorArrowOpenStyle: CSSProperties = {
  transform: 'rotate(180deg)'
};

export const workflowSelectorTriggerStyle: CSSProperties = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  width: '100%',
  padding: `${WORKFLOW_SELECTOR_PADDING_Y} ${WORKFLOW_SELECTOR_PADDING_RIGHT} ${WORKFLOW_SELECTOR_PADDING_Y} ${WORKFLOW_SELECTOR_PADDING_LEFT}`,
  border: `1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR}`,
  borderRadius: WORKFLOW_SELECTOR_BORDER_RADIUS,
  backgroundColor: WORKFLOW_SELECTOR_BACKGROUND,
  cursor: 'pointer',
  fontSize: WORKFLOW_SELECTOR_FONT_SIZE,
  lineHeight: WORKFLOW_SELECTOR_LINE_HEIGHT,
  whiteSpace: 'normal',
  wordBreak: 'break-all'
};

export const workflowSelectorDropdownPanelStyle: CSSProperties = {
  marginTop: '4px',
  backgroundColor: WORKFLOW_SELECTOR_BACKGROUND,
  border: `1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR}`,
  borderRadius: WORKFLOW_SELECTOR_BORDER_RADIUS,
  boxShadow: WORKFLOW_SELECTOR_DROPDOWN_SHADOW,
  overflow: 'hidden'
};

export const workflowSelectorDropdownListStyle: CSSProperties = {
  overflowY: 'auto',
  maxHeight: '150px',
  margin: 0,
  padding: 0,
  listStyle: 'none'
};

export const workflowSelectorDropdownItemStyle: CSSProperties = {
  padding: '8px 12px',
  cursor: 'pointer',
  backgroundColor: WORKFLOW_SELECTOR_BACKGROUND,
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  borderBottom: `1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR}`
};

export const workflowSelectorSearchInputStyle: CSSProperties = {
  marginBottom: 0,
  border: 'none',
  borderBottom: `1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR}`,
  borderRadius: 0,
  boxShadow: 'none'
};

export const workflowSelectorTriggerCss = css`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: ${WORKFLOW_SELECTOR_PADDING_Y} ${WORKFLOW_SELECTOR_PADDING_RIGHT} ${WORKFLOW_SELECTOR_PADDING_Y}
    ${WORKFLOW_SELECTOR_PADDING_LEFT};
  border: 1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR};
  border-radius: ${WORKFLOW_SELECTOR_BORDER_RADIUS};
  background-color: ${WORKFLOW_SELECTOR_BACKGROUND};
  cursor: pointer;
  font-size: ${WORKFLOW_SELECTOR_FONT_SIZE};
  line-height: ${WORKFLOW_SELECTOR_LINE_HEIGHT};
`;

export const workflowSelectorDropdownPanelCss = css`
  margin-top: 4px;
  background-color: ${WORKFLOW_SELECTOR_BACKGROUND};
  border: 1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR};
  border-radius: ${WORKFLOW_SELECTOR_BORDER_RADIUS};
  box-shadow: ${WORKFLOW_SELECTOR_DROPDOWN_SHADOW};
  overflow: hidden;
`;

export const workflowSelectorDropdownListCss = css`
  overflow-y: auto;
  max-height: 150px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const workflowSelectorDropdownItemCss = css`
  padding: 8px 12px;
  cursor: pointer;
  background-color: ${WORKFLOW_SELECTOR_BACKGROUND};
  white-space: normal;
  word-wrap: break-word;
  border-bottom: 1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR};

  &:last-child {
    border-bottom: none;
  }
`;

export const workflowSelectorSearchInputCss = css`
  &&& {
    width: 100%;
    margin-bottom: 0;
    border: none;
    border-bottom: 1px solid ${WORKFLOW_SELECTOR_BORDER_COLOR};
    border-radius: 0;
    box-shadow: none;
  }
`;

export { WorkflowSelectorArrow } from './workflow_selector_arrow';
